import { Injectable } from "@angular/core";
import { ToastService } from "@siu/shared";
import { HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  constructor(protected toast: ToastService) {}

  protected handleErrorResponse = (error: HttpErrorResponse) => {
    if (error.status == 401) {
      this.toast.error("Su sesión ha expirado. Por favor actualice la página.");
    }

    // return Observable.throw(error);
    return throwError(error);
  };

  protected downloadFile = (data: any, type: string, fileName: string) => {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);

    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
}
